import { Nav, Row, Col } from "react-bootstrap"
import  styles from "./AccountManagement.module.scss"
import { useContext, useState } from "react"
import InformationPage from "./InformationPage"
import { AuthContext } from "AuthContext"
import ChangePasswordPage from "./ChangePasswordPage"
import SubscriptionInfoPage from "./SubscriptionInfoPage"
import StudentOptionsPage from "./StudentOptionsPage"

type ActiveAccountTab = "information" | "password" | "subscription" | "student-options" | "register-lms"

const AccountManagement = () => {
    const [activeTab, setActiveTab] = useState<ActiveAccountTab>("information")
    const { isLoggedIn, isStudent, trackingEnabled } = useContext(AuthContext)

    if (!isLoggedIn) {
        window.location.href = "/account/log-in"
    } else if (isStudent && trackingEnabled) {
        window.location.href = "/dashboard/student/assignments"
    } else if (isStudent && !trackingEnabled) {
        window.location.href = "/"
    }

  return (
    <div className="min-vh-100">
        <div className="m-auto mt-4 d-flex flex-column flex-md-row justifiy-content-center align-items-center">
            <h1 className={"fw-bold m-auto mb-2"}>Account Management</h1>
        </div>
        <hr className="w-75 m-auto mt-4" />
        <Nav variant="pills" defaultActiveKey={activeTab} className={`mt-4 justify-content-center ${styles.container}`}>
            <Row className="g-2">
                {/* {Information} */}
                <Col xs={12} sm={6} md={3}>
                    <Nav.Item 
                        role="button"
                        onClick={() => setActiveTab("information")}
                        className={`rounded px-5 w-100 d-flex justify-content-center ${activeTab === "information" ? `bg-primary ${styles.activeTab}` : `bg-white ${styles.tab}`}`}>
                        <Nav.Link eventKey="information" active={activeTab === "information"}>
                            <span className={`${activeTab === "information" && `text-white fw-bold`}`}>Information</span>
                        </Nav.Link>
                    </Nav.Item>
                </Col>
                {/* {Password} */}
                <Col xs={12} sm={6} md={3}>
                    <Nav.Item
                        onClick={() => setActiveTab("password")}
                        role="button" 
                        className={`rounded px-5 w-100 d-flex justify-content-center ${activeTab === "password" ? `bg-primary ${styles.activeTab}` : `bg-white ${styles.tab}`}`}>
                        <Nav.Link eventKey="password" active={activeTab === "password"}>
                            <span className={`${activeTab === "password" && `text-white fw-bold`}`}>Password</span>
                        </Nav.Link>
                    </Nav.Item>
                </Col>
                {/* {Subscription} */}
                <Col xs={12} sm={6} md={3}>
                    <Nav.Item
                        role="button"
                        onClick={() => setActiveTab("subscription")}
                        className={`rounded px-5 w-100 d-flex justify-content-center ${activeTab === "subscription" ? `bg-primary ${styles.activeTab}` : `bg-white ${styles.tab}`}`}>
                        <Nav.Link eventKey="subscription" active={activeTab === "subscription"}>
                            <span className={`${activeTab === "subscription" && `text-white fw-bold`}`}>Subscription</span>
                        </Nav.Link>
                    </Nav.Item>
                </Col>
                {/* {Student Options Or Create Student} */}
                <Col xs={12} sm={6} md={3}>
                    <Nav.Item
                        role="button"
                        onClick={() => setActiveTab("student-options")}
                        className={`rounded px-5 w-100 d-flex justify-content-center ${activeTab === "student-options" ? `bg-primary ${styles.activeTab}` : `bg-white ${styles.tab}`}`}>
                        <Nav.Link eventKey="student-options" active={activeTab === "student-options"}>
                            <span className={`${activeTab === "student-options" && `text-white fw-bold`}`}>Student&nbsp;Options</span>
                        </Nav.Link>
                    </Nav.Item>
                </Col>
                {/* {LMS} */}
                {false && <Col xs={12} sm={6} md={3}>
                    <Nav.Item
                        role="button"
                        onClick={() => setActiveTab("register-lms")}
                        className={`rounded px-5 w-100 d-flex justify-content-center ${activeTab === "register-lms" ? `bg-primary ${styles.activeTab}` : `bg-white ${styles.tab}`}`}>
                        <Nav.Link eventKey="register-lms" active={activeTab === "register-lms"}>
                            <span className={`${activeTab === "register-lms" && `text-white fw-bold`}`}>Register&nbsp;LMS</span>
                        </Nav.Link>
                    </Nav.Item>
                </Col>}
            </Row>
        </Nav>
        {activeTab === "information" && <InformationPage />}
        {activeTab === "password" && <ChangePasswordPage />}
        {activeTab === "subscription" && <SubscriptionInfoPage />}
        {activeTab === "student-options" && <StudentOptionsPage />}
    </div>
  )
}

export default AccountManagement
